import React, {useEffect, useState, useRef} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';

import {myService} from '@app/services/daohuuService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {Tabs, HRTag} from "@components";
import {
    image_root  , INIT_ROLE_MENU
} from "@app/const/AppSetting";

import {useTranslation} from "react-i18next";
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {findObjInArr} from "@app/utils/CommonFunctions";
import GioitinhListComponent from '@app/pages/FUtil/GioitinhListComponent';
import AnchayListComponent from '@app/pages/FUtil/AnchayListComponent';
import NhadanListComponent from '@app/pages/FUtil/NhadanListComponent';
import NewDatePicker from '@app/pages/FUtil/NewDatePicker';
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import DaohuuLayoutComponent from '@app/pages/FUtil/DaohuuLayoutComponent';
import ThannhanEdit from '@app/pages/FMasterData/FDaohuu/ThannhanEdit';
import TailieuEdit from '@app/pages/FMasterData/FDaohuu/TailieuEdit';
import './buttonmoveto.css';

import CountriesListComponent from '@app/pages/FUtil/CountriesListComponent';
import CityListComponent from '@app/pages/FUtil/CityListComponent';
import DistrictListComponent from '@app/pages/FUtil/DistrictListComponent';
import WardsListComponent from '@app/pages/FUtil/WardsListComponent';
import {ClipLoader} from "react-spinners";
import DaoCardGenerator from "@pages/FUtil/DaoHuuTheDaoGenerator";

function DaohuuEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);

    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const taiLieuRef = useRef(null);
    const thannhanRef = useRef(null);
    const thongtinRef = useRef(null);

    const scrollToTaiLieu = () => {
        taiLieuRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToThannhan= () => {
        thannhanRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToThongtin= () => {
        thongtinRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const initial = {
        nhadan_fks :[],
        nhadan_fk :null,
        phanquyen_fks :[],
        id: id || 0,
        ten : '',
        dia_chi: '',
        dien_thoai: '',
        email:'',
        cccd:'',
        ngay_sinh:'',
        ward_code:'',
        district_code:'',
        city_code:'',
        country_fk:'380',
        nguoidandatobj:null, // gọi trên BE tương tự daohuuObj
        nghe_nghiep:'',
        gioitinh_fk : null,
        anchay_fk : null,
        ghi_chu: '',
        all: false
    };

    const [obj, setObj] = useState({...initial});

    const onChangeInput = (e) => {
        console.log(e.target);
        const { name, value } = e.target;

        setObj((prevState) => {
            let newState = { ...prevState, [name]: value };

            // Nếu thay đổi Thành phố -> Xóa Quận/Huyện & Phường/Xã
            if (name === "city_code") {
                newState.district_code = "";
                newState.ward_code = "";
            }
            // Nếu thay đổi Quận/Huyện -> Xóa Phường/Xã
            else if (name === "district_code") {
                newState.ward_code = "";
            }

            return newState;
        });

        setHandleToogle((prevSelected) => !prevSelected);
    };

    const createRs = async () => {

        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;
                console.log(userX);
                setObj(userX);

            });
        }
        else
        {
            const cqtemp = await mainService.getAllNhadan({ path_access:currController});
            setObj((prevState) => ({
                ...prevState,
                nhadan_fks: cqtemp.map(obj=> ({ ...obj, checked: false }))
            }));
        }

    };

    useEffect(async () => {

        await checkRole({
            pathname: location.pathname,
            isAddMode,
            currController,
            history
        });

        await createRs();

    }, []);

    const saveClick = async () => {
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if(!data.ten || data.ten.length === 0)
        {
            alert('Vui lòng nhập tên');
            return;
        }
        if(isAddMode)
        {

        }
        isAddMode ?  createDaohuu(data) : update(data);

    };


    const backBrowse = () => {
        history.push('/'+currController);
    };



    async function createDaohuu(data) {
        setLoading(true);
        // delete data.ma;
        const result = await myService.Create(data);
        if (result.status ==="1") {
            alertService.success(result.msg);

            history.push('/'+currController+'/edit/'+ result.data );

        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }
    async function update(data) {
        setLoading(true);

        const result = await myService.Update(id,data);



        if (result.status ==="1") {
            alertService.success(result.msg);

        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }


    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }



    let htmlButtonSave = '';

    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <>
                <Button
                    className="btn btn-success mr-1"
                    icon="right fas fa-angle-left"
                    onClick={saveClick}
                >
                    <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"  } </i>
                </Button>

                {/* Thêm button Thẻ Đạo chỉ khi không phải Add Mode */}
                {!isAddMode && (
                    <DaoCardGenerator obj={obj} />
                )}
            </>
        );
    }

    // CSS Styles
    const avatarContainerStyle = {
        width: '120px',
        height: '160px',
        border: '2px solid #e3f2fd',
        borderRadius: '8px',
        background: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        position: 'relative'
    };

    const avatarImageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '6px'
    };

    const formLabelStyle = {
        fontWeight: '500',
        color: '#495057',
        marginBottom: '5px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    };

    const formControlStyle = {
        border: '1px solid #ced4da',
        borderRadius: '6px',
        padding: '8px 12px',
        fontSize: '14px',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff'
    };

    const iconStyle = {
        fontSize: '14px',
        marginRight: '8px'
    };

    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                {/* Navigation buttons - Fixed on right side like original */}
                { !isAddMode && (
                    <div style={{
                        position: 'fixed',
                        right: '0',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: '1000',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToThongtin}
                        >
                            Thông tin chung
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToTaiLieu}
                        >
                            Tài liệu
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #6c757d 0%, #5a6268 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToThannhan}
                        >
                            Thân nhân
                        </button>
                    </div>
                )}

                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>

                <div className="tab-pane fade show active" label="Thông tin bán hàng" id="thongtinnhanvien">
                    <div className="card-body" ref={thongtinRef}>
                        <HRTag title={`Thông tin profile - SỐ HIỆU: ${obj?.ma}`} />

                        {/* Avatar Section - Smaller */}
                        {!isAddMode && (
                            <div className="row mb-3">
                                <div className="col-12 d-flex justify-content-center">
                                    <div style={avatarContainerStyle}>
                                        <img
                                            src={obj.anhdaidien}
                                            alt="Avatar"
                                            style={avatarImageStyle}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Personal Information Row 1 */}
                        <div className="row mb-3">
                            <div className="col-md-5">
                                <label style={{...formLabelStyle, fontWeight: '600'}}>
                                    <i className="fas fa-user text-primary" style={iconStyle}></i>
                                    Họ Tên <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={formControlStyle}
                                    name="ten"
                                    id="ten"
                                    value={obj.ten}
                                    onChange={onChangeInput}
                                    placeholder="Nhập họ và tên"
                                />
                            </div>
                            <div className="col-md-3">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-phone text-success" style={iconStyle}></i>
                                    Điện thoại
                                </label>
                                <input
                                    maxLength="10"
                                    type="text"
                                    className="form-control"
                                    style={formControlStyle}
                                    name="dien_thoai"
                                    id="dien_thoai"
                                    value={obj.dien_thoai}
                                    onChange={onChangeInput}
                                    placeholder="Số điện thoại"
                                />
                            </div>
                            <div className="col-md-4">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-id-card text-info" style={iconStyle}></i>
                                    Căn cước công dân
                                </label>
                                <input
                                    maxLength="12"
                                    type="text"
                                    className="form-control"
                                    style={formControlStyle}
                                    name="cccd"
                                    id="cccd"
                                    value={obj.cccd}
                                    onChange={onChangeInput}
                                    placeholder="Số CCCD"
                                />
                            </div>
                        </div>

                        {/* Personal Information Row 2 */}
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-birthday-cake text-warning" style={iconStyle}></i>
                                    Ngày sinh
                                </label>
                                <NewDatePicker
                                    className="form-control w-100"
                                    isV2
                                    id="ngay_sinh"
                                    name="ngay_sinh"
                                    value={obj.ngay_sinh}
                                    onDayChange={onChangeInput}
                                />
                            </div>
                            <div className="col-md-4">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-envelope text-secondary" style={iconStyle}></i>
                                    Email
                                </label>
                                <input
                                    maxLength="100"
                                    type="email"
                                    className="form-control"
                                    style={formControlStyle}
                                    name="email"
                                    id="email"
                                    value={obj.email}
                                    onChange={onChangeInput}
                                    placeholder="Email"
                                />
                            </div>
                            <div className="col-md-2">
                                <GioitinhListComponent
                                    required="required"
                                    gioitinh_fk={obj.gioitinh_fk}
                                    onChange={(opt) => onChangeInput({ target: { name: "gioitinh_fk", value: opt?.value } })}
                                />
                            </div>
                            <div className="col-md-3">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-briefcase text-dark" style={iconStyle}></i>
                                    Nghề nghiệp
                                </label>
                                <input
                                    maxLength="250"
                                    type="text"
                                    className="form-control"
                                    style={formControlStyle}
                                    name="nghe_nghiep"
                                    id="nghe_nghiep"
                                    value={obj.nghe_nghiep}
                                    onChange={onChangeInput}
                                    placeholder="Nghề nghiệp"
                                />
                            </div>
                        </div>

                        {/* Religious Information */}
                        <div className="row mb-3">
                            <div className="col-md-2">
                                <AnchayListComponent
                                    anchay_fk={obj.anchay_fk}
                                    onChange={(opt) => onChangeInput({ target: { name: "anchay_fk", value: opt?.value } })}
                                />
                            </div>
                            <div className="col-md-5">
                                <NhadanListComponent
                                    nhadan_fk={obj.nhadan_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "nhadan_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                            <div className="col-md-5">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-hand-holding-heart text-danger" style={iconStyle}></i>
                                    Người dẫn dắt
                                </label>
                                <DaohuuAutocompleteComponent
                                    path_access={currController}
                                    currentSuggestion={obj.nguoidandatobj}
                                    onChange={(e) => onChangeInput({ target: { name: 'nguoidandatobj', value: e?.value } })}
                                />
                            </div>
                        </div>

                        {/* Address Information Row 1 */}
                        <div className="row mb-3">
                            <div className="col-md-2">
                                <CountriesListComponent
                                    country_fk={obj.country_fk}
                                    onChange={(opt) => onChangeInput({ target: { name: "country_fk", value: opt?.value } })}
                                />
                            </div>
                            <div className="col-md-3">
                                <CityListComponent
                                    city_code={obj.city_code}
                                    onChange={(opt) => onChangeInput({ target: { name: "city_code", value: opt?.value } })}
                                />
                            </div>
                            <div className="col-md-3">
                                <DistrictListComponent
                                    district_code={obj.district_code}
                                    city_code={obj.city_code}
                                    onChange={(opt) => onChangeInput({ target: { name: "district_code", value: opt?.value } })}
                                />
                            </div>
                            <div className="col-md-4">
                                <WardsListComponent
                                    ward_code={obj.ward_code}
                                    district_code={obj.district_code}
                                    onChange={(opt) => onChangeInput({ target: { name: "ward_code", value: opt?.value } })}
                                />
                            </div>
                        </div>

                        {/* Address Information Row 2 */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-map-marker-alt text-danger" style={iconStyle}></i>
                                    Số nhà / Địa chỉ chi tiết
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={formControlStyle}
                                    name="dia_chi"
                                    id="dia_chi"
                                    value={obj.dia_chi}
                                    onChange={onChangeInput}
                                    placeholder="Số nhà, tên đường..."
                                />
                            </div>
                        </div>

                        {/* Notes Section */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-sticky-note text-warning" style={iconStyle}></i>
                                    Ghi chú
                                </label>
                                <textarea
                                    rows="3"
                                    maxLength="500"
                                    className="form-control"
                                    style={{...formControlStyle, resize: 'vertical', minHeight: '60px'}}
                                    name="ghi_chu"
                                    id="ghi_chu"
                                    value={obj.ghi_chu}
                                    onChange={onChangeInput}
                                    placeholder="Nhập ghi chú..."
                                />
                            </div>
                        </div>

                        {/* Additional Sections */}
                        {!isAddMode && (
                            <div ref={taiLieuRef}>
                                <HRTag title="Tài liệu" />
                                <TailieuEdit id={id} />
                            </div>
                        )}
                        {!isAddMode && (
                            <div ref={thannhanRef}>
                                <HRTag title="Thân nhân" />
                                <ThannhanEdit id={id} />
                            </div>
                        )}

                    </div>
                </div>
            </div>
            {/* /.card-body */}
            <div className="card-footer">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>
            </div>
        </div>
    );
}

export {DaohuuEdit};